'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import SuggestedMessages from '../SuggestedMessages'
import usePostReply from '../../hooks/usePostReply/usePostReply'

const CoreSuggestedMessages = () => {
  const { conversation } = useConversationContext()
  const { postReplyRequest } = usePostReply()

  if (!conversation?.suggestedMessages?.length) return null

  return (
    <SuggestedMessages
      messages={conversation.suggestedMessages}
      onMessageClick={value => postReplyRequest({ value })}
      trackingContext={{
        transactionId: conversation.transactionId,
        itemIds: conversation.transaction?.order?.itemIds.toString(),
      }}
    />
  )
}

export default CoreSuggestedMessages
